import { render } from "./PlayoutEmptyPlaceholderV2.vue?vue&type=template&id=140a6f25"
import script from "./PlayoutEmptyPlaceholderV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutEmptyPlaceholderV2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutEmptyPlaceholderV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "140a6f25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('140a6f25', __exports__)) {
    api.reload('140a6f25', __exports__)
  }
  
  module.hot.accept("./PlayoutEmptyPlaceholderV2.vue?vue&type=template&id=140a6f25", () => {
    api.rerender('140a6f25', render)
  })

}


export default __exports__